<template>
<div class="container">
    <h2>Feature Flags</h2>
    <div class="text-start">
        <div class="list-group w-auto mb-4" v-for="(value, key) in flags" :key="key">
            <a href="#" class="list-group-item list-group-item-action d-flex gap-3 py-3" aria-current="true">
                <div v-if="value.status == 1">
                    <img src="../assets/good.svg" alt="Your SVG Image"/>
                </div>
                <div v-else>
                    <img src="../assets/bad.svg" alt="Your SVG Image"/>
                </div>

                <div class="d-flex gap-2 w-100 justify-content-between">
                    <div>
                        <h6 class="mb-0 text-capitalize fw-semibold">{{ key }}</h6>
                        <!-- <p class="mb-0 opacity-75">Active: {{ value.implemented }}</p> -->
                        <p class="mb-0 opacity-75">Customer Message: {{ value.message }}</p>
                        <p class="mb-0 opacity-75">What is the flag for: {{ value.message }}</p>
                    </div>
                    <small class="opacity-50 text-nowrap">Active: {{ value.implemented ? "Active" : "Inactive" }}</small>
                </div>
            </a>
        </div>
    </div>
</div>
</template>

<script>
import flagsData from "../utils/flags.json";
export default {
    name: "flags",
    data() {
        return {
            flags: flagsData
        }
    },
}
</script>

<style>

</style>
